import AxiosService from './AxiosService'

class AppRestService {
  get(): Promise<any> {
    return AxiosService.get('/apps')
  }

  getById(id: number): Promise<any> {
    return AxiosService.get('/apps/' + id)
  }

  getByTemplate(template: string): Promise<any> {
    return AxiosService.get('/apps/templates/' + template)
  }

  getDefinitions(): Promise<any> {
    return AxiosService.get('/apps/definitions')
  }

  getDefinitionByType(type: string): Promise<any> {
    return AxiosService.get('/apps/definitions/' + type)
  }

  create(app: any): Promise<any> {
    return AxiosService.post('/apps/', app)
  }

  update(app: any): Promise<any> {
    return AxiosService.put('/apps/' + app.id, app)
  }

  delete(id: any): Promise<any> {
    return AxiosService.delete('/apps/' + id)
  }
}

export default new AppRestService()
